export default "__VITE_ASSET__CHwc6fhG__"